import defaultSegmentProps from '@shared/default-segment-props';

import { types } from '../redux';

export default {
    [types.trackRequestFailed.pending]: [
        {
            providers: {
                segment: {
                    type: 'track',
                    name: 'fe_core_error_logged',
                    props: {
                        ...defaultSegmentProps,
                        path: '#context.errorPath',
                        failed_api_name: '#context.failedApiName',
                    },
                },
            },
        },
    ],
    [types.trackReportNotFound.pending]: [
        {
            providers: {
                segment: {
                    type: 'track',
                    name: 'fe_core_error_logged',
                    props: {
                        ...defaultSegmentProps,
                        path: '#context.errorPath',
                        error_message: 'report_not_found',
                    },
                },
            },
        },
    ],
};
